import { Pipe, PipeTransform } from "@angular/core";
import * as _ from 'underscore';

/**
 * first retourne le premier élément
 * @example | first
 */
@Pipe({ name: "first" })
export class ReturnFirst implements PipeTransform {
  transform(array: any[]): any {
    return _.first(array)
  }
}

/**
 * last retourne le dernier élément d'un array
 * @example | last
 */
@Pipe({ name: "last" })
export class ReturnLast implements PipeTransform {
  transform(array: any[]): any {
    return _.last(array)
  }
}

/**
 * without retourne l'Array sans l'item en question
 * @param item l'item qu'on ne veut pas dans l'array
 * @example | without:item
 */
@Pipe({ name: "without" })
export class ReturnWithout implements PipeTransform {
  transform(array: any[], item: any): any {
    return _.without(array, item)
  }
}